export default __webpack_public_path__ + "static/media/girl3.23a9ce98.jpg";